import React from 'react';

export default function RosterLoadingSkeleton() {
  return (
    <div className="roster-loading-skeleton" aria-busy="true" aria-live="polite">
      <div className="roster-loading-banner">
        <div className="roster-loading-spinner" />
        <div>
          <strong>Loading roster…</strong>
          <p>Fetching players and free-agent statuses from Google Sheets.</p>
        </div>
      </div>
      <div className="roster-loading-grid">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="roster-loading-card">
            <div className="skeleton-line w-60" />
            <div className="skeleton-line w-40" />
            <div className="skeleton-line w-80" />
            <div className="skeleton-bars">
              {Array.from({ length: 8 }).map((__, j) => (
                <div key={j} className="skeleton-bar" />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
